import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    alignItems: 'center',
    gap: spacing.l,
    flexGrow: 1,
  },
  textsContainer: {
    alignItems: 'center',
    gap: spacing.m,
    paddingHorizontal: spacing.m,
  },
  textsInfo: {
    alignItems: 'center',
    gap: spacing.xxs,
  },
  transferContainer: {
    alignSelf: 'stretch',
    gap: spacing.l,
  },
  shareButton: {
    alignSelf: 'stretch',
  },
  transactionLinks: {
    flex: 1,
    justifyContent: 'flex-end',
    alignSelf: 'stretch',
  },
  links: {
    flexDirection: 'row',
    gap: spacing.m,
    alignItems: 'center',
  },
  link: {
    flex: 1,
    alignItems: 'center',
  },
}));
